import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class GoogleMapsLoaderService {
    private scriptLoaded = false;
    public googleMapsAvailable = false;

    constructor() {}

    loadGoogleMaps(apiKey: string): Promise<void> {
        return new Promise((resolve) => {
            resolve();
            if (this.scriptLoaded) {
                this.googleMapsAvailable =
                    typeof (window as any).google?.maps !== 'undefined';
                resolve();
                return;
            }

            this.scriptLoaded = true;

            // Crear el script para Google Maps
            const script = document.createElement('script');
            script.src =
                'https://maps.googleapis.com/maps/api/js?key=' +
                environment.apigoogle +
                `&libraries=places,marker,geometry&language=ES&region=GT&loading=async`;
            script.async = true;
            script.defer = true;

            script.onload = () => {
                this.googleMapsAvailable = true;
                resolve();
            };

            script.onerror = () => {
                console.warn('Google Maps bloqueado o no disponible.');
                this.googleMapsAvailable = false;
                resolve();
            };
            setTimeout(() => {
                if (!this.googleMapsAvailable) {
                    console.warn(
                        'Timeout: Google Maps no respondió (simulando bloqueo).'
                    );
                    resolve();
                }
            }, 5000);
            document.head.appendChild(script);
        });
    }
}
